export default __webpack_public_path__ + "static/media/Aura-Egg__93.1aeb32d4.png";